<template>
  <router-btn :text="$t('servicesystem.common_objects.document.download')" :icon="'mdi-download'" :color="'primary'"
    :loading="loading" :disabled="false" :textbtn="textbtn" :large="large" :small="small" @Press="action">
  </router-btn>
</template>

<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";
import ClientAPIMixin from "@/api/ClientAPIMixin";
import BlobFileMixin from "@/helpers/Mixins/BlobFileMixin";

export default {
  name: "DownloadCheckListReportBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },
  mixins: [ClientAPIMixin],

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    async action() {
      this.loading = true;
      var fileName = `Order-${this.orderId}_CheckListReport.pdf`;
      console.log("Downloading checklist report", fileName);
      var file = await this.downloadCheckListReport(this.jobId, fileName);
      await BlobFileMixin.methods.saveBlobToFile(file.blob, file.filename);
      this.loading = false;
    },
  },

  computed: {
    jobDetails() {
      return this.$store.getters["JobHub/JobDetails"];
    },
    orderId() {
      var job = this.jobDetails;
      return job ? (job.OrderId || 'S' + job.Id) : null;
    },
    jobId() {
      return parseInt(this.$route.params.jobId) || null;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>
